import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { AccountService } from 'app/store/services/account.service';
import { ActivatedRoute } from '@angular/router';
import { SessionService } from 'app/store/services/session.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IUserSessionData } from 'app/store/models/user.model';
import { Store } from '@ngrx/store';
import { IReducers } from '../../store/reducers';
import { openSnackbar } from '../../store/actions/page.action';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-bcc-manage',
  templateUrl: './bcc-manage.component.html',
  styleUrls: ['./bcc-manage.component.scss'],
})
export class BccManageComponent implements OnInit {
  type;

  sessionData: IUserSessionData;

  formGroup: FormGroup;
  formReady = false;

  cancelButtonProperties: Button = {
    text: 'Cancel',
    color: ButtonColor.RED,
    size: ButtonSize.SMALL,
    route: ['/messages'],
    style: 'rounded',
  };

  updateButtonProperties: Button = {
    text: 'SAVE',
    color: ButtonColor.ORANGE,
    size: ButtonSize.SMALL,
    onClick: () => this.update(),
    style: 'rounded',
  };

  removeButtonProperties: Button = {
    text: 'Remove',
    color: ButtonColor.RED,
    size: ButtonSize.SMALL,
    onClick: () => this.remove(),
    style: 'outline',
  };

  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private accountService: AccountService,
    private activatedroute: ActivatedRoute,
    private sessionService: SessionService,
    private readonly store$: Store<IReducers>,
  ) {
  }

  ngOnInit() {
    // snackbar utility here for handling success error

    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe(sessionData => {
        this.activatedroute.data.subscribe(data => {
          this.type = data.type;
          if (this.type === 'all') {
            this.updateButtonProperties.text = 'SAVE';
          }
          this.accountService.getBcc(this.type).subscribe(response => {
            const mail = response.email ? response.email : '';
            this.formGroup = new FormGroup({
              email: new FormControl(mail, Validators.email),
            });
            this.sessionData = sessionData;
            this.formReady = true;
          });
        });
      });
  }

  update() {
    if (this.formGroup.valid) {
      this.updateBcc(this.formGroup.getRawValue());
      return;
    }

    this.formGroup.markAllAsTouched();
  }

  updateBcc(form: any): void {
    this.accountService.setBcc(this.type, form).subscribe(
      result => {
        if (result && result.success) {
          this.store$.dispatch(
            openSnackbar({
              snackbarData: {
                data: {
                  type: 'success',
                  message: 'BCC email successfully updated',
                },
              },
            }),
          );
          return;
        }
      },
      (error: HttpErrorResponse) => {
        this.store$.dispatch(
          openSnackbar({
            snackbarData: {
              data: {
                type: 'error',
                message: error.error,
              },
            },
          }),
        );
      },
    );
  }

  remove() {
    this.formGroup.patchValue({
      email: '',
    });
    const form = {
      email: '',
    };
    this.updateBcc({ email: '' });
  }
}
